import { Upload } from "antd";
import { toast } from "react-toastify";

export const validateImageUpload = (file) => {
  const allowedTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
  ];

  if (!allowedTypes.includes(file.type)) {
    toast.error("Only JPG, JPEG and PNG images are allowed.");
    return Upload.LIST_IGNORE;
  }

  if (file.size > 2 * 1024 * 1024) {
    toast.error("Image size should not exceed 2 MB.");
    return Upload.LIST_IGNORE;
  }

  return false; // Prevent auto upload
};